<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
  <h5>Signin with Google to access the Firebase database</h5>
  <br>
  <div class="row">
    <div class="col-md-6">
      <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
    </div>
  </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
  <h1 style="display:inline-block">Event Management</h1>
  <i class="bi bi-question-circle" style="font-size: 1.5em;margin-left:20px;color:gray" (click)="showinfo = !showinfo"></i>
  <button class="btn btn-danger btn-sm" (click)="deleteOlderThan7Days()" style="float:right;margin-left: 10px;">Delete Older Than 7 Days</button>
  <br>
  <div *ngIf="showinfo" style="margin:20px;padding:20px;background-color:lightgray;border:solid 1px gray">
    An exercise is a collaborative event where a teacher leads students through a virtual experience called a Virtex exercise.
    Both the teacher and students are associated with a unique identifier called the exercise ID.
    This ID links them specifically to the exercise, ensuring that only participants who possess the correct exercise ID can join.
    As a result, the exercise remains secure and accessible only to authorized participants.
  </div>
  <div class="row">
        <div class="col-md-5">
          <h5>Overview</h5>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>Property</th>
                <th>Value</th>
              </tr>
            </thead>
            <tbody>
                            <tr>
                <td>Size of Events node</td>
                <td>{{ eventsSize | number: '1.2-2' }} kbytes</td>
              </tr>
              <tr>
                <td>Number of Events</td>
                <td>{{ events.length }}</td>
              </tr>
                            <tr>
                <td>Number of Events older than 7 days</td>
                <td>{{ nOlderThan7Days }}</td>
              </tr>
            </tbody>
          </table>

    </div>
    <div class="col-md-7">
      <button class="btn btn-primary btn-sm" (click)="showOnlyToday()" style="margin-left: 10px;">Show Only Today</button>
      <button class="btn btn-primary btn-sm" (click)="showLast7Days()" style="margin-left: 10px;">Show Last 7 Days</button>
      <button class="btn btn-primary btn-sm" (click)="showAllEvents()" style="margin-left: 10px;">Show All Events</button>



      <br><br><br>
      <h3>Filter Events</h3>
      <div class="inline"> <sa-input-text [(text)]="exerciseid" [title]="'exerciseid'" [required]="'none'"></sa-input-text></div>
      <div class="inline"> <sa-input-text [(text)]="playerid" [title]="'playerid'" [required]="'none'"></sa-input-text></div>
      <div class="inline"> <sa-input-text [(text)]="type" [title]="'type'" [required]="'none'"></sa-input-text></div>
      <button class="btn btn-primary btn-sm" (click)="filter()" style="margin-left: 10px;">Filter</button>
      <button class="btn btn-primary btn-sm" (click)="clear()" style="margin-left: 10px;">Clear</button>
    </div>
  </div>


  <br><br>
  Listed are {{ eventsDisplay.length }} events

  <table class="table table-bordered table-striped">
    <thead>
      <tr>
        <th>id</th>
        <th>exerciseid<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(events,'exerciseid',sortArray)"></i></th>
        <th>playerid</th>
        <th>timestamp</th>
        <th>datetime<i class="bi bi-arrow-down-up" style="font-size: 1.0em;" (click)="sortGeneric(events,'datetime',sortArray)"></i></th>
        <th>type</th>
        <th>data</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of eventsDisplay">
        <td>{{ item.id }}</td>
        <td>{{ item.exerciseid }}</td>
        <td>{{ item.playerid }}</td>
        <td>{{ item.timestamp }}</td>
        <td>{{ item.datetime | date:'short' }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.data | json }}</td>
      </tr>
    </tbody>
  </table>
  <div class="row" hidden="true">
    <div class="col-md-3">
      <h5>Overview</h5>
      <div *ngFor="let level1 of aggregated" class="group">
        <div class="group-header">Exercise <b>{{ level1.group }}</b> ({{ level1.items.length }} items)</div>
        <i class="bi bi-pencil" style="font-size: 1.0em;margin-left:15px;color:green" (click)="deleteExercise(level1.group)"></i>
        <div *ngFor="let level2 of level1.items" class="group nested">
          <div class="group-header">Player <b>{{ level2.group }}</b> ({{ level2.items.length }} items)</div>
          <div *ngFor="let level3 of level2.items" class="group nested">
            <i class="bi bi-pencil" style="font-size: 1.0em;margin-left:15px;color:green" (click)="showEvents(level1.group,level2.group,level3.group)"></i>
            <div style="display:inline-block;margin-left:10px" class="group-header">Type <b>{{ level3.group }}</b> ({{ level3.items.length }} items)

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-9">
      <h5>Selected Records</h5>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Property</th>
            <th>Type</th>
            <th>Exercise</th>
            <th>Player</th>
            <th>TimeStamp</th>
            <th>Time ago</th>
            <th>Data</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of selectedItems">
            <td>{{item.id}}</td>
            <td>{{item.type}}</td>
            <td>{{item.exerciseid}}</td>
            <td>{{item.playerid}}</td>
            <td>{{item.timestamp}}</td>
            <td>{{item.datetime}}</td>
            <td>{{item.data | json}}</td>
            <td><button class="btn btn-warning btn-sm">Delete</button></td>
          </tr>
        </tbody>
      </table>
      <!-- {{selectedItems | json}} -->
    </div>
  </div>

</div>